<template>
  <div></div>
</template>

<script>
function detachDocListeners(docListeners) {
  return new Promise((res, rej) => {
    // Object.values(docListeners).forEach((f) => {
    //   if (typeof f === 'function') {
    //     f();
    //   }
    // });
    Object.keys(docListeners).forEach((listenerName) => {
      if (typeof docListeners[listenerName] === 'function') {
        // keep appStatus listener so non-auth user can receive appStatus updates
        if (listenerName !== 'appStatus') {
          docListeners[listenerName]();
        }
      }
    });
    res(true);
  });
}
export default {
  async created() {
    // Detach all FB document listeners
    var docListeners = await this.$store.getters.docListeners;
    // Object.values(docListeners).forEach((f) => f());

    // Make sure doclisteners finish detaching before logging out -- avoid console error:
    // "Uncaught Error in onSnapshot: FirebaseError: Missing or insufficient permissions."
    // UPDATE: Nope... still getting the error (tho - like before - NOT every time user logs out... hmmm)
    // ... not gonna worry about it - not detrimental, but... would like to know what's causing it.
    var d = await detachDocListeners(docListeners);
    console.log('promise result', d);
    await this.$fapi.logout();

    if (this.$fapi.error) {
      this.$store.dispatch('setErrorMsg', this.$fapi.error);
      this.$router.push('/alert');
    } else {
      this.$store.dispatch('uploadTracker/clearImageCounts');
      this.$store.dispatch('uploadTracker/clearImageNamesAll');
      this.$store.dispatch('clearUserProfile');
      this.$store.dispatch('clearDocListeners');

      //   this.$store.dispatch('setLastAction', 'logout'); // DON'T NEED ANYMORE!!
      // Redirect to login page with 'goodbye' message displayed above the login form.
      this.$router.push({ path: '/', query: { redirect: 'logout' } });
    }
  },
};
</script>

<style>
</style>